/* Royal Deccan Cart Rewards V2 - lightweight live refresh for Shopify Dawn. */
(function () {
  'use strict';
  if (window.__royalCartRewardsV2) return;
  window.__royalCartRewardsV2 = true;

  var debounceTimer = null;
  var requestNumber = 0;
  var drawerSelector = '#CartDrawer [data-rd-cart-rewards]';

  function money(paise) {
    var rupees = Math.max(0, Number(paise || 0)) / 100;
    var hasPaise = Math.round(rupees * 100) % 100 !== 0;
    return 'Rs. ' + new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: hasPaise ? 2 : 0,
      maximumFractionDigits: 2
    }).format(rupees);
  }

  function setText(root, selector, value) {
    var element = root.querySelector(selector);
    if (element && element.textContent !== value) element.textContent = value;
  }

  function showStage(root, name, show) {
    var element = root.querySelector('[data-rd-stage="' + name + '"]');
    if (element) element.hidden = !show;
  }

  function setProgress(root, kind, percentage) {
    var bar = root.querySelector('[data-rd-' + kind + '-bar]');
    var fill = root.querySelector('[data-rd-' + kind + '-fill]');
    if (bar) bar.setAttribute('aria-valuenow', String(percentage));
    if (fill) fill.style.width = percentage + '%';
  }

  function renderCart(cart) {
    var root = document.querySelector(drawerSelector);
    if (!root || !cart || !Array.isArray(cart.items)) return;

    var count = Number(cart.item_count || 0);
    root.hidden = count === 0;
    if (!count) return;

    var freeThreshold = Number(root.dataset.shippingThreshold || 149900);
    var offerThreshold = Number(root.dataset.offerThreshold || 500000);
    var subtotal = Math.max(0, Number(cart.items_subtotal_price ?? cart.total_price ?? 0));
    var eligible = cart.items.reduce(function (sum, item) {
      return sum + (item.gift_card ? 0 : Math.max(0, Number(item.final_line_price || 0)));
    }, 0);
    var freeRemaining = Math.max(0, freeThreshold - subtotal);
    var offerRemaining = Math.max(0, offerThreshold - eligible);
    var freeComplete = freeRemaining === 0;
    var offerComplete = offerRemaining === 0;
    var freePercent = Math.min(100, Math.round(subtotal * 100 / freeThreshold));
    var offerPercent = Math.min(100, Math.round(eligible * 100 / offerThreshold));

    showStage(root, 'shipping', !freeComplete);
    showStage(root, 'free-success', freeComplete);
    showStage(root, 'offer-progress', freeComplete && !offerComplete);
    showStage(root, 'offer-success', freeComplete && offerComplete);

    setText(root, '[data-rd-free-remaining]', money(freeRemaining));
    setText(root, '[data-rd-cart-subtotal]', money(subtotal));
    setText(root, '[data-rd-offer-remaining]', money(offerRemaining));
    setText(root, '[data-rd-eligible-subtotal]', money(eligible));
    setProgress(root, 'free', freePercent);
    setProgress(root, 'offer', offerPercent);
  }

  function cartUrl() {
    var path = window.routes && window.routes.cart_url;
    if (path) return path.replace(/\/$/, '') + '.js';
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  function refresh() {
    var current = ++requestNumber;
    if (!document.querySelector(drawerSelector)) return;
    fetch(cartUrl(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        if (current !== requestNumber) return;
        renderCart(cart);
      })
      .catch(function () {
        /* Leave Shopify-rendered milestone content intact if offline. */
      });
  }

  function scheduleRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 100);
  }

  function start() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // Dawn's cart drawer swaps HTML after add and quantity/remove updates.
    // Watch only section replacements, not our own progress text updates.
    var observer = new MutationObserver(function (records) {
      var changedCart = records.some(function (record) {
        var target = record.target;
        if (target.nodeType !== 1) return false;
        if (target.closest('[data-rd-cart-rewards]')) return false;
        if (target.id === 'CartDrawer' || target.id === 'CartDrawer-CartItems' ||
            target.tagName === 'CART-DRAWER-ITEMS' || target.classList.contains('drawer__inner')) {
          return true;
        }
        var nodes = Array.prototype.slice.call(record.addedNodes);
        return nodes.some(function (node) {
          return node.nodeType === 1 &&
            (node.matches('[data-rd-cart-rewards], #CartDrawer-CartItems, cart-drawer-items, .drawer__inner') ||
              node.querySelector('[data-rd-cart-rewards], #CartDrawer-CartItems, cart-drawer-items'));
        });
      });
      if (changedCart) scheduleRefresh();
    });
    observer.observe(drawer, { childList: true, subtree: true });

    // Also listen to Dawn's event bus, which is used on quantity updates.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && Array.isArray(event.cartData.items) &&
            typeof event.cartData.items_subtotal_price === 'number') {
          renderCart(event.cartData);
        } else {
          scheduleRefresh();
        }
      });
    }

    document.addEventListener('cart:updated', scheduleRefresh);
    document.addEventListener('cart:refresh', scheduleRefresh);

    // Initial state comes from Liquid, so we make no unnecessary request on load.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
